export default __webpack_public_path__ + "images/f8e68303bfea980e8298ef97a5e20cae-medieval.webp";